import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const AnimatedSection = ({ 
  children, 
  className = '', 
  direction = 'up', // up, left, right, scale
  delay = 0,
  threshold = 0.1 
}) => {
  const [ref, isVisible] = useScrollAnimation({ threshold });
  
  const directionClasses = {
    up: '',
    left: 'from-left',
    right: 'from-right',
    scale: 'scale'
  };

  const delayClasses = {
    0: '',
    100: 'delay-100',
    200: 'delay-200',
    300: 'delay-300',
    400: 'delay-400',
    500: 'delay-500',
    600: 'delay-600'
  };

  return (
    <div
      ref={ref}
      className={`animate-on-scroll ${directionClasses[direction]} ${delayClasses[delay] || ''} ${isVisible ? 'visible' : ''} ${className}`}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;